import { render, staticRenderFns } from "./TextToSpeech.vue?vue&type=template&id=2e50fe6e&"
import script from "./TextToSpeech.vue?vue&type=script&lang=js&"
export * from "./TextToSpeech.vue?vue&type=script&lang=js&"
import style0 from "./TextToSpeech.vue?vue&type=style&index=0&id=2e50fe6e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports